/**
 * @fileoverview a helper function for getting the current unix timestamp
 * @url https://confluence.braze.com/display/ENG/Date+and+time+handling#Dateandtimehandling-getNowTimestamp
 *
 * @note this file is allowed to use "new Date" as it's a datetime util
 */
/* eslint-disable local-eslint-rules/no-new-date */
import { getUnixTime } from "date-fns";

/**
 * returns the current time as a Unix timestamp
 * @deprecated use `import { getNowTimestamp } from "@services/time"` instead
 */
export const getNowTimestamp = () => getUnixTime(new Date());
